<template>
  <!-- <div style="color:white;text-align:right">
    <span style="color:black">Share this recipe: </span>
    <twitter-share
      has_icon 
      :share_message="twitterShareMessage ? twitterShareMessage : null"
    ></twitter-share>
    <vue-goodshare-reddit has_icon />
    <vue-goodshare-email 
      has_icon 
    />
  </div> -->

  <div style="color:white;text-align:right">
    <span style="color:black">Share this map: </span>
    <twitter-share
      has_icon 
      :share_message="twitterShareMessage ? twitterShareMessage : null"
      :page_url="shareUrl ? shareUrl : null"
    ></twitter-share>
      <!-- title_social="Tweet"  -->
    <!-- <vue-goodshare-facebook has_icon has_counter title_social="Facebook" />
    <vue-goodshare-reddit has_icon title_social="Reddit" /> -->
    <!-- <vue-goodshare-facebook has_icon /> -->
    <vue-goodshare-reddit 
      has_icon 
      :page_url="shareUrl ? shareUrl : null"
    />
    <vue-goodshare-email 
      has_icon 
      :page_url="shareUrl ? shareUrl : null"
    />
  </div>
</template>

<script>
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue'
import VueGoodshareReddit from 'vue-goodshare/src/providers/Reddit.vue'
import VueGoodshareTelegram from 'vue-goodshare/src/providers/Telegram.vue'
import VueGoodshareLine from 'vue-goodshare/src/providers/Line.vue'
import VueGoodshareEmail from 'vue-goodshare/src/providers/Email.vue'
import TwitterShare from '@/components/TwitterShare'

export default {
  props: {
    twitterShareMessage: {
      type: String,
      required: false
    },
    shareUrl: {
      type:String,
      requried: false
    }
  },
  components:{
    VueGoodshareFacebook,
    VueGoodshareReddit,
    VueGoodshareTelegram,
    VueGoodshareLine,
    VueGoodshareEmail,
    TwitterShare
  }
}

</script>

